import Button from "@components/Button";
import CustomInput from "../CustomInput/CustomInput";
import styles from "./SignInComponent.module.css";
import { Link } from "react-router-dom";
import useAuth from "@hooks/useAuth";
import { useState } from "react";

const SignInComponent = () => {
  const { handleSignIn } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = () => {
    handleSignIn(formData);
  };

  return (
    <div className={styles.Wrapper}>
      <CustomInput
        showLabel
        label={"Email"}
        name="email"
        onChange={handleInputChange}
      />
      <CustomInput
        showLabel
        label={"Password"}
        name="password"
        onChange={handleInputChange}
        type="password"
      />
      <div className={styles.RememberMeWrapper}>
        <input
          type="checkbox"
          name="rememberMe"
          checked={formData.rememberMe}
          onChange={handleInputChange}
        />
        <span> Remember me </span>
      </div>
      <Link to="/forgotpassword" className={styles.ForgotPasswordText}>
        Forgot password
      </Link>
      <Button btnType={"primary"} text={"Login"} onClick={handleSubmit} />
      <Link to="/signup">
        <Button btnType={"transparent"} text={"Dont have an account? Signup"} />
      </Link>
    </div>
  );
};

export default SignInComponent;
